import {Component, Input} from '@angular/core';
import {ColumnInfo} from '../description-card-info';

@Component({
  selector: 'app-description-card-info-item',
  templateUrl: './description-card-info-item.component.html',
  styleUrls: ['./description-card-info-item.component.scss']
})
export class DescriptionCardInfoItemComponent {
  @Input() info: ColumnInfo;
}
